import React from 'react';
import AgreedConsumptionDTO from 'features/contracts/dtos/AgreedConsumptionDTO';
import InfoItemInline from 'features/shared/components/infoItem/InfoItemInline';
import PageCard from 'features/shared/components/card/PageCard';
import { formatNumber } from 'features/shared/helpers/Formatters';
import { useTranslation } from 'react-i18next';

type Props = {
  consuptions: AgreedConsumptionDTO[];
  className?: string;
}

const ContractAgreedConsumptionsCard = ({ consuptions, className }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // sub-renders
  const renderConsumptions = () => { 
    return consuptions.map((consuption, index) =>
      <InfoItemInline 
        title={consuption.label!}
        value={formatNumber(consuption.value!, 3, consuption.unit)}
        key={index}
      />
    );
  }

  // render
  return (
    <PageCard title={tLabels("contractAgreedConsumptionsCard.cardTitle")} cardClassName={className}>
      {renderConsumptions()}
    </PageCard>
  )
}

export default ContractAgreedConsumptionsCard;